export const DURATIONS = {
  slow: 14000,
  medium: 10000,
  fast: 6000,
};

export const SLOTS = {
  actionsEnd: "actions-end",
  title: "title",
  message: "message",
  link: "link",
};

export const CSS = {
  actionsEnd: "actions-end",
  close: "close",
  container: "container",
  containerBottom: "container--bottom",
  containerBottomEnd: "container--bottom-end",
  containerBottomStart: "container--bottom-start",
  containerQueued: "container--queued",
  containerTop: "container--top",
  containerTopEnd: "container--top-end",
  containerTopStart: "container--top-start",
  content: "content",
  contentContainer: "content-container",
  dismissProgress: "dismiss-progress",
  footer: "footer",
  icon: "icon",
  containerSlottedInShell: "container--slotted-in-shell",
  queueCount: "queue-count",
  queueCountActive: "queue-count--active",
  textContainer: "text-container",
};
